import { render, staticRenderFns } from "./ReceiptSetting.vue?vue&type=template&id=07789f32&scoped=true"
import script from "./ReceiptSetting.vue?vue&type=script&lang=js"
export * from "./ReceiptSetting.vue?vue&type=script&lang=js"
import style0 from "./ReceiptSetting.vue?vue&type=style&index=0&id=07789f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07789f32",
  null
  
)

export default component.exports